import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

//Compponent
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
import SubjectListing from '../organisms/SubjectListing/SubjectListingContainer';
import FormCreateSubject from '../organisms/FormCreateSubject/FormCreateSubjectContainer';
import FormDeleteSubject from '../organisms/FormDeleteSubject/FormDeleteSubjectContainer';

class DashboardSubjects extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedSubject: {},
			subjects: [],
			updateState: false,
			deleteState: false,
			modalClass: '',
			subjectName: ''
		}

		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.createSubjectClickHandler = this.createSubjectClickHandler.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		// Helps to open and close the pop up
		this.setState({ modalClass: '' });

		// IDK how to deal with this in a better way.
		// Need to read more on handing inmutable data
		if (nextProps.selectedSubject) {
			if (nextProps.selectedSubject.selectedSubject.type === 'update') {
				this.setState({ 
					selectedSubject: nextProps.selectedSubject.selectedSubject,
					deleteState: false,
					updateState: true
				 });
				 this.createSubjectClickHandler();
			} else if (nextProps.selectedSubject.selectedSubject.type === 'delete') {
				this.setState({ 
					selectedSubject: nextProps.selectedSubject.selectedSubject,
					deleteState: true,
					updateState: false
				 });
				 this.createSubjectClickHandler();
			} else if (nextProps.selectedSubject.selectedSubject.type === 'loaded') {
				// Right after it has been updated or deleted
				this.setState({ 
					selectedSubject: {},
					updateState: false, 
					deleteState: false 
				});
			}
		} 
	
	}
	componentWillMount() {
		this.props.fetchCurrentBot(this.props.match.params.id);
	}
	createSubjectClickHandler(e) {
		if (e) e.preventDefault();
		// Ugly fix to close the pop up of new subject by checking if undefined
		if (this.state.modalClass === '' || this.state.modalClass === undefined) {
			document.addEventListener('click', this.handleOutsideClick, false);
			document.addEventListener('keydown', this.handleOutsideClick, false);
			// Only add modalClass active when it's not delete state
			if (!this.state.deleteState) {
				this.setState({ modalClass: 'modal--active' });
			}
			
		} else {
			this.setState({ 
				modalClass: '',
				updateState: false,
				deleteState: false,
				selectedSubject: {}
			});
			document.removeEventListener('click', this.handleOutsideClick, false);
			document.removeEventListener('keydown', this.handleOutsideClick, false);
		}
	}
	handleOutsideClick(e) {
		let targetClass = e.target.className;

		// Closing from the X
		if (targetClass.includes('fa-close') || e.keyCode === 27) { // Checking if they press ESC key
			targetClass = 'modal--active';
		}
		// ignore clicks on the component itself
		if (!targetClass.includes('modal--active')) {
			return;
		}
		
		this.createSubjectClickHandler(e);
	}
	renderHandler(currentBot) {
		if (currentBot.data === undefined || currentBot.loading === true) { return false; }
		return (
			<div className="dashboardBody">
				<DashboardNavigation/>
				<div className="dashboardMainContent">
					<div className="container">
						<SubjectListing 
							data={this.props.data}
							heading={`${this.props.data.subjectListing.heading} ${currentBot.data.name}`}
							currentBot={currentBot.data}
							addSubjectClick={(e) => this.createSubjectClickHandler(e)}
						/>
					</div>
				</div>
				<FormCreateSubject
					modalClass={this.state.deleteState ? '' : this.state.modalClass}
					updateState={this.state.updateState}
					selectedSubject={this.state.selectedSubject}
				/>

				<FormDeleteSubject
					modalClass={this.state.deleteState ? this.state.modalClass : ''}
					selectedSubject={this.state.selectedSubject}
					onClickCancel={(e) => this.createSubjectClickHandler(e)}
				/>
			</div>
		)
	}
	render() {
		const currentBot = this.props.currentBot; // Reads the store

		return this.renderHandler(currentBot);
	}

}

export default withRouter(DashboardSubjects);


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardSubjects.jsx